import Component from '../core/Component'

export default class MailSender extends Component {
    constructor(element) {
        super(element)
    }

    prepare() {
        this.element.addEventListener('click', ::this.handleClick)
    }

    handleClick(event) {
        const link = `mailto:?subject=KPMG | vyrostlijsme.cz - ${this.element.dataset.subject}&body=${this.element.dataset.content}..\n\n${document.URL}`
        this.element.href = encodeURI(link)
    }
}